import { fieldError } from "./common";
import { getMaxPastedContentLength } from "./envLimits";

export function formatDocumentContentLimitMessage(
  actualLength,
  maxLength = getMaxPastedContentLength(),
) {
  return `Document content is too large (${actualLength.toLocaleString()} characters). Maximum allowed is ${maxLength.toLocaleString()} characters. Shorten the text or upload a smaller file.`;
}

export function assessDocumentContentLength(
  text,
  maxLength = getMaxPastedContentLength(),
) {
  const cleaned = String(text ?? "").trim();
  const length = cleaned.length;
  return {
    text: cleaned,
    length,
    maxLength,
    exceeded: length > maxLength,
  };
}

export function validateDocumentContent(field, value, errors = {}) {
  const { length, maxLength, exceeded } = assessDocumentContentLength(value);
  if (!length || !exceeded) {
    return errors;
  }

  errors[field] = fieldError(
    field,
    "MAX_LENGTH",
    formatDocumentContentLimitMessage(length, maxLength),
  );
  return errors;
}
